import { MapPin, Navigation, Globe } from "lucide-react";
import { Reveal } from "./Reveal";

const CURRENT = [
  { city: "Bengaluru", areas: ["JP Nagar 9th Phase", "Kanakapura Road side", "Marathahalli"] },
];
const EXPANDING = [
  { city: "Bengaluru", areas: ["Brookfield", "Electronic City", "HSR", "Whitefield"] },
  { city: "Hyderabad", areas: ["Manikonda"] },
];

const Locations = () => (
  <section className="bg-ink text-white bg-blueprint relative overflow-hidden" data-testid="locations-section">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
      <Reveal>
        <div className="flex items-center gap-3 font-mono text-[11px] tracking-[0.35em] text-skope uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-skope" />
          Our Kitchens
        </div>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 font-display font-bold text-4xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl">
          BUILT WHERE YOUR CUSTOMERS ARE.
        </h2>
      </Reveal>
      <Reveal delay={0.14}>
        <p className="mt-6 text-white/55 leading-relaxed max-w-2xl">
          Our kitchens are positioned inside key delivery zones, helping partner brands serve customers with fast,
          reliable delivery.
        </p>
      </Reveal>

      <div className="mt-16 grid lg:grid-cols-3 gap-6">
        <Reveal delay={0.2}>
          <div className="h-full border border-skope/40 bg-surface p-8" data-testid="locations-current">
            <div className="flex items-center gap-3">
              <MapPin size={18} className="text-skope" />
              <span className="font-mono text-[10px] tracking-[0.3em] text-skope uppercase">Currently In — Live</span>
            </div>
            {CURRENT.map((c) => (
              <div key={c.city} className="mt-6">
                <h3 className="font-display font-semibold text-2xl text-white">{c.city}</h3>
                <ul className="mt-3 space-y-2">
                  {c.areas.map((a) => (
                    <li key={a} className="flex items-center gap-3 text-white/60">
                      <span className="w-1.5 h-1.5 rounded-full bg-skope shrink-0" />
                      {a}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <p className="mt-6 text-xs text-white/35 leading-relaxed">
              Operational kitchens, live and serving partner brands today.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.28}>
          <div className="h-full border border-white/12 bg-surface/60 p-8" data-testid="locations-expanding">
            <div className="flex items-center gap-3">
              <Navigation size={18} className="text-skope" />
              <span className="font-mono text-[10px] tracking-[0.3em] text-white/50 uppercase">Expanding To — Upcoming</span>
            </div>
            {EXPANDING.map((c) => (
              <div key={c.city} className="mt-6">
                <h3 className="font-display font-semibold text-2xl text-white/90">{c.city}</h3>
                <ul className="mt-3 space-y-2">
                  {c.areas.map((a) => (
                    <li key={a} className="flex items-center gap-3 text-white/50">
                      <span className="w-1.5 h-1.5 rounded-full border border-skope shrink-0" />
                      {a}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <p className="mt-6 text-xs text-white/35 leading-relaxed">
              Upcoming locations — planned, not yet operational.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.36}>
          <div className="h-full border border-white/12 bg-surface/60 p-8 flex flex-col" data-testid="locations-pan-india">
            <div className="flex items-center gap-3">
              <Globe size={18} className="text-skope" />
              <span className="font-mono text-[10px] tracking-[0.3em] text-white/50 uppercase">Pan India</span>
            </div>
            <h3 className="mt-6 font-display font-semibold text-2xl text-white/90 leading-snug">
              Expanding PAN India based on demand from food brands.
            </h3>
            <p className="mt-4 text-white/50 leading-relaxed text-sm">
              While our current kitchen network is concentrated in key Bengaluru and Hyderabad locations, Skope is open
              to expanding PAN India based on demand from food brands.
            </p>
            <p className="mt-auto pt-6 text-xs text-white/35">
              Have demand in your city? <span className="text-skope">Talk to us.</span>
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Locations;
